import { datadogRum } from "@datadog/browser-rum";
import { useClientEnv } from "@magalu/rave/config";
import { useEffect, ReactNode } from "react";

import { getAppVersion } from "@utils/getAppVersion";

export type ClientEnvType = {
  datadog: {
    dataDogEnable: boolean;
    dataDogEnv: "production" | undefined;
    dataDogSessionRate: number;
    dataDogSessionReplay: number;
  };
};

export type DataDogRumProps = {
  children: ReactNode;
};

const DataDogRum = ({ children }: DataDogRumProps) => {
  const {
    client: {
      datadog: {
        dataDogEnable,
        dataDogEnv,
        dataDogSessionRate,
        dataDogSessionReplay,
      },
    },
  } = useClientEnv() as { client: ClientEnvType };
  const appVersion = getAppVersion();

  useEffect(() => {
    if (!dataDogEnable || !!datadogRum.getInitConfiguration()) {
      return;
    }

    datadogRum.init({
      applicationId: "9bd96497-f01d-416e-8b35-3d3962fb26c1",
      clientToken: "pub41693b5b18e193af31ddbf6a2140fec7",
      defaultPrivacyLevel: "mask-user-input",
      env: dataDogEnv,
      service: "imperio",
      sessionReplaySampleRate: dataDogSessionReplay,
      sessionSampleRate: dataDogSessionRate,
      site: "us5.datadoghq.com",
      version: `v${appVersion}`,
    });
  }, []);

  return <>{children}</>;
};

export default DataDogRum;
